import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
// import UserPrefsContext from "../../context/UserPrefs/UserPrefsContext";
import EVIncentives from "../../components/EVIncentives/EVIncentives";
import EVJumbotron from "../../components/EVJumbotron/EVJumbotron";
import ChargingMap from "../../components/LocationMap/ChargingMap";
import CostOfOwnership from "../../components/CostOfOwnership/CostOfOwnership";
// import getPaymentDetails from "../../functions/vehicle/getPaymentDetails";

import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import isPHEV from "../../functions/vehicle/isPHEV";
// import { FormatCarName } from "../../utils/Helpers/Format";
// import { set } from "react-ga";

const UsedEV = ({ electricVehicles, userLocation, ip, uuid }) => {
     // const userPrefs = useContext(UserPrefsContext);
     const [usedEv, setUsedEv] = useState(null);
     const [usedEvs, setUsedEvs] = useState(null);
     const { evId } = useParams();
     const [isResolved, setIsResolved] = useState(false);

     let car;

     useEffect(() => {
          const normalizeVehiclePart = (value = "") =>
               decodeURIComponent(value).replace(/_/g, " ").replace(/\s+/g, " ").trim().toLowerCase();

          const setElectricVehicles = () => {
               const evIdParam = evId || null;

               if (electricVehicles && evIdParam) {
                    const evId = evIdParam.split(":");
                    const make = normalizeVehiclePart(evId[0]);
                    const model = normalizeVehiclePart(evId[1]);
                    const trim = normalizeVehiclePart(evId[2]);

                    const allUsedEvs = electricVehicles.filter((ev) => {
                         return (
                              normalizeVehiclePart(ev.make) === make &&
                              normalizeVehiclePart(ev.model) === model &&
                              normalizeVehiclePart(ev.trim) === trim
                         );
                    });
                    setUsedEv(allUsedEvs[0] || null);
                    setUsedEvs(allUsedEvs);
                    setIsResolved(true);

                    document.title = make ? `Used Vehicle: ${make} ${model}` : "";
               } else {
                    setUsedEv(null);
                    setUsedEvs(null);
                    setIsResolved(Boolean(electricVehicles));
               }
          };
          setElectricVehicles();
     }, [electricVehicles, evId]);

     const ignoreSuperchargerStations = car && isPHEV(car);

     const renderEV = usedEv ? (
          <>
               <EVJumbotron car={usedEv} incentives={usedEv.incentives} cars={usedEvs} setUsedEv={setUsedEv} />
               <CostOfOwnership cars={[usedEv, usedEv.equivalent_gas_vehicle]} usedEv={true} />
               <EVIncentives incentives={usedEv.incentives} car={usedEv} usedEv={true} />
               <section className="container-fluid charging-map pinot">
                    <section className="container">
                         <ChargingMap
                              userLocation={userLocation}
                              ignoreSuperchargerStations={ignoreSuperchargerStations}
                              hideList={true}
                         />
                    </section>
               </section>
          </>
     ) : isResolved ? (
          <div className="container text-center">
               <p className="h4">Vehicle not found</p>
          </div>
     ) : (
          <div className="container text-center">
               <LoadingSpinner />
          </div>
     );

     return <>{renderEV}</>;
};

export default UsedEV;

UsedEV.propTypes = {
     electricVehicles: PropTypes.array,
     userLocation: PropTypes.object,
     ip: PropTypes.string,
     uuid: PropTypes.string
};
